import React from 'react';
import BlueButton from '../../buttons/BlueButton';
import WhiteButton from '../../buttons/WhiteButton';
import logo from './covi@2x.png';
import Back from './backstep';
import Proceso from './process';


class Welcome extends React.Component {

    state = {
        init: true //!(this.props.onboarding && this.props.onboarding.programaciones)
    }

    handleConfig = event => {
        this.setState({ init: false })
    }

    handleProcess = (id) => event => {
        const { onboarding } = this.props;
        const { programaciones } = onboarding;

        let i = programaciones.map((p) => p.proceso).indexOf(id)
        if (i < 0) {
            let info = {
                proceso: id,
                sts: false,
                programaciones: []
            }
            programaciones.push(info)
        } else {
            programaciones.splice(i, 1)
        }

        this.props.onSave('programaciones', [...programaciones]);
    }

    handleChangeProg = (id, column, value) => {

        const { onboarding } = this.props;
        const { programaciones } = onboarding;

        let i = programaciones.map((p) => p.proceso).indexOf(id)
        if (i < 0) {
            let info = {
                proceso: id,
                sts: false,
                programaciones: []
            }
            info[column] = value;
            programaciones.push(info)
        } else {
            programaciones[i][column] = value;
        }

        console.log(programaciones);

        this.props.onSave('programaciones', [...programaciones]);
    }

    handleAddProg = (id, local, week, hour) => event => {
        console.log(id, local, week, hour)
        const { onboarding } = this.props;
        const { programaciones } = onboarding;

        let i = programaciones.map((p) => p.proceso).indexOf(id)
        if (i < 0) {
            let info = {
                proceso: id,
                sts: false,
                programaciones: [{
                    dow: week.toString(),
                    hora: hour,
                    local: local
                }]
            }
            programaciones.push(info)
        } else {
            programaciones[i].programaciones.push({
                dow: week.toString(),
                hora: hour,
                local: local
            })
        }

        this.props.onSave('programaciones', [...programaciones]);
    }

    handleDeleteProg = (id, index) => event => {
        const { onboarding } = this.props;
        const { programaciones } = onboarding;

        console.log(id, index);

        const i = programaciones.map((p) => p.proceso).indexOf(id)
        if (i >= 0) {
            console.log(i)
            programaciones[i].programaciones.splice(index, 1);
        }

        this.props.onSave('programaciones', [...programaciones]);
    }

    render() {
        const { intl, onboarding, procesos } = this.props;
        const { init } = this.state;
        const { programaciones, locales } = onboarding;
        console.log(programaciones)

        const familias = procesos.reduce((total, item) => {
                                        if (total.indexOf(item.familia) === -1) {
                                            total.push(item.familia);
                                        }
                                        return total;
                                    }, [])
                                    .sort((a, b) => a.ordenfamilia > b.ordenfamilia ? -1 : 1);

        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    {init
                        ? <div className="ob_welcome">
                            <span className="ob_covid_title margin_bottom_12">{intl.formatMessage({ id: 'ob_covid_title' })}</span>
                            <img alt="logo" className="ob_covid_img padding_top_48 padding_bottom_48" src={logo} />
                            <span className="ob_covid_subtitle margin_top_24">{intl.formatMessage({ id: 'ob_covid_subtitle' })}</span>
                            <span className="ob_covid_subtitle ob_covid_question margin_top_12 margin_bottom_12">{intl.formatMessage({ id: 'ob_covid_question' })}</span>
                        </div>
                        : <div className="ob_welcome text_align_left_important">
                            <span className="ob_process_title margin_bottom_24 ">{intl.formatMessage({ id: 'ob_process_title' })}</span>
                            <div className="ob_process_message margin_bottom_24 ">
                                {intl.formatMessage({ id: 'ob_process_message' })}
                                <span className="ob_process_message_bold margin_left_6">{intl.formatMessage({ id: 'ob_process_message_bold' })} </span>
                            </div>
                            {familias &&
                                familias
                                    .map((f) => {
                                        const procesosfamilia = procesos.filter((p) => p.familia === f)
                                        console.log(procesosfamilia, programaciones)
                                        return (
                                            <div key={`familia-${f}` }className="flex_full_column width100">
                                                <span className="ob_process_family">{f}</span>
                                                {procesosfamilia &&
                                                    procesosfamilia
                                                        .sort((a, b) => a.ordenproceso > b.ordenproceso ? 1 : -1)
                                                        .map((p) =>
                                                            <Proceso
                                                                {...this.props}
                                                                key={`proceso-${p.id}`}
                                                                info={p}
                                                                id={p.id}
                                                                locales={locales}
                                                                list={programaciones.filter((p) => procesos.find((f) => f.id === p.proceso))}
                                                                programacion={programaciones.find((pg) => pg.proceso === p.id)}
                                                                onAdd={this.handleAddProg}
                                                                onDelete={this.handleDeleteProg}
                                                                onChange={this.handleChangeProg}
                                                                onProcess={this.handleProcess}
                                                            />
                                                        )
                                                }
                                            </div>    
                                        )
                                    })
                            }

                        </div>
                    }
                </div>
                {init
                    ? <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                        <WhiteButton id="ob_skip" className="ob_next" onClick={this.props.onNext} />
                        <BlueButton id="ob_config" className="ob_next margin_left_12" onClick={this.handleConfig} />
                    </div>
                    : <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                        <BlueButton id="next" className="ob_next" onClick={this.props.onNext} />
                    </div>
                }
            </div>
        );
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/covid.js